module.exports = __webpack_public_path__ + "img/intelligent-bg1.f54aff44.png";